import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import Communications from "./communications.service";
import { ENV, Misc } from "../constants";
import {  IAxiosOptions } from "../models/api.model";

export const AXIOS_REQUEST_CANCELLED = "AXIOS_REQUEST_CANCELLED";
let jwtToken = typeof window !== "undefined" ? localStorage.getItem(Misc.LOCAL_STORAGE_JWT_TOKEN) ?? "" : undefined;


Communications.updateLoginUserTokenSubject.subscribe((token: string | undefined) => {
    jwtToken = token;
});

const getHeaders = (headers: any) => ({
    Accept: "application/json",

    "Content-Type": "application/json",
    Authorization: `Bearer ${jwtToken}`,
    ...headers,
});

const request = async (method: string, url: string, payload: any = {}, headers = {}, options: IAxiosOptions = {}, progressCallback?: (progress: number) => void) => {
    if (payload instanceof FormData) {
        headers = { ...headers, "Content-Type": "multipart/form-data" };
    }
    const config: AxiosRequestConfig = {
        method,
        url,
        headers: getHeaders(headers),
        data: ["get", "delete"].includes(method) ? undefined : payload,
        params: method === "get" ? payload : undefined,
        onUploadProgress: progressCallback ? (event) => progressCallback(Math.floor((event.loaded / event.total) * 100)) : undefined,
        ...options,
    };
    return handleResponse(axios(config));
};

const handleResponse = async (request: Promise<AxiosResponse>) => {
    try {
        const response = await request;
        if (ENV.ENABLE_HTTP_LOGS) console.log("Response:", response.data);
        return { ...response.data, status: response.status };
    } catch (err: any) {
        if (ENV.ENABLE_HTTP_LOGS) console.error("API Error:", err);

        const response = err.response || { data: null, status: 500 };
        const error = { ...response.data, status: response.status };
        if (response.status === 401) Communications.logoutSubject.next();
        if (response.status === 403) Communications.RestrictedAccessSubject.next(true);
        if (axios.isCancel(err)) {
            error.status = 499;
            error.reason = AXIOS_REQUEST_CANCELLED;
        }
        throw error;
    }
};

const ApiService = {
    get: (url: string, params = {}, headers = {}, options: IAxiosOptions = {}) => request("get", url, params, headers, options),
    post: (url: string, data: any, headers = {}, options: IAxiosOptions = {}, progressCallback?: (progress: number) => void) => request("post", url, data, headers, options, progressCallback),
    patch: (url: string, data: any, headers = {}, options: IAxiosOptions = {}, progressCallback?: (progress: number) => void) => request("patch", url, data, headers, options, progressCallback),
    put: (url: string, data: any, headers = {}, options: IAxiosOptions = {}, progressCallback?: (progress: number) => void) => request("put", url, data, headers, options, progressCallback),
    delete: (url: string, data = {}, headers = {}, options: IAxiosOptions = {}) => request("delete", url, data, headers, options),
} as { [key: string]: any };

export default ApiService;
